import { render, staticRenderFns } from "./ViewApproval.vue?vue&type=template&id=afe6ff64&lang=pug"
import script from "./ViewApproval.vue?vue&type=script&lang=js"
export * from "./ViewApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports